// extracted by mini-css-extract-plugin
module.exports = {"btn":"beginForm-module--btn--1GskZ"};